export const baseTaxingAmount = 100;
